import React, { useRef, useState, useEffect } from 'react'
import { styled } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core/styles'
import { useGlobal } from '../../../../utils/useGlobal'
import * as firebase from '../../../../utils/firebase'
import * as Navigator from '../../../../common/Navigator'
import * as Storage from '../../../../common/Storage'
import * as Logger from '../../../../common/Logger'
import * as StringUtils from '../../../../common/StringUtils'
import * as ScreenUtils from '../../../../common/ScreenUtils'
import * as DataUtils from '../../../../common/DataUtils'
import * as Constants from '../../../../common/Constants'
import ProgressBar from '../../../widgets/ProgressBar'
import Strings from '../../../../common/Strings'
import IButton from '../../../controls/IButton'
import ITextField from '../../../controls/ITextField'
import IFormControl from '../../../controls/IFormControl'
import ITypography from '../../../controls/ITypography'
import ITable from '../../../controls/ITable'
import ITableBody from '../../../controls/ITableBody'
import ITableCell from '../../../controls/ITableCell'
import ITableContainer from '../../../controls/ITableContainer'
import IPaper from '../../../controls/IPaper'
import ITableRow from '../../../controls/ITableRow'
import IDialog from '../../../controls/IDialog'
import IDialogActions from '../../../controls/IDialogActions'
import IDialogContent from '../../../controls/IDialogContent'
import IDialogTitle from '../../../controls/IDialogTitle'
import ICircularProgress from '../../../controls/ICircularProgress'
import PhoneInput from '../../../widgets/PhoneInput'
import SearchIcon from '@material-ui/icons/Search'
import ToastView, { TOAST_ERROR, TOAST_SUCCESS } from '../../../widgets/ToastView'
import { createPropsWithActions, setLoading, showToast } from '../../../../common/ViewUtils'
import Styles from '../../../../common/Styles'
import IImage from '../../../controls/IImage'

const SearchButton = styled(IButton)({
  background: 'white',
  boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  border: 0,
  borderRadius: 3,
  color: Styles.primaryBgColor,
  height: 35
})

const ScheduleButton = styled(IButton)({
  background: 'white',
  boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  border: 0,
  borderRadius: 3,
  color: Styles.primaryBgColor,
  height: 35
})

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: Styles.contentMaxWidth,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  heading: {
    fontSize: Styles.headingTitleSize
  },
  searchBox: {
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexFlow: 'column'
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    }
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: Styles.inputWidth
  },
  gridList: {
    justifyContent: 'center'
  },
  storeInfo: {
    marginLeft: 20,
    width: '100%'
  },
  card: {
    display: 'flex',
    width: '100%'
  },
  scheduleButton: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))

function SearchView({ props }) {
  Logger.log('SearchView')

  const [keyword, setKeyword] = useState('')

  useEffect(() => {

  }, [])

  const onSearchClick = (e) => {
    e.preventDefault()
    if (props.onSearchClick) {
      props.onSearchClick(keyword.toLowerCase())
    }
  }

  const classes = useStyles()

  return <form><div className={classes.searchBox}>
    <ITextField className={classes.textField} inputProps={{ style: { fontSize: Styles.searchFontSize } }} label={Strings.searchCustomerHint} value={keyword} onChange={(event) => { setKeyword(event.target.value) }} />
    <SearchButton type='submit' startIcon={<SearchIcon />} onClick={(e) => onSearchClick(e)}>{Strings.search}</SearchButton>
  </div></form>
}

function AddCustomerView({ props }) {
  Logger.log('AddCustomerView')

  const { user, settings } = useGlobal()
  const storeId = user[Constants.ID]
  const userId = user[Constants.ID]
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [openDialog, setOpenDialog] = useState(false)
  const [loadingDialog, setLoadingDialog] = useState(false)

  useEffect(() => {

  }, [])

  const addCustomer = async () => {
    if (!StringUtils.stringEmpty(email)) {
      if (!StringUtils.validateEmail(email)) {
        showToast(props, TOAST_ERROR, Strings.errorEmailInvalid)
        return
      }
    }
    if (StringUtils.stringEmpty(firstName) || StringUtils.stringEmpty(phone)) {
      showToast(props, TOAST_ERROR, Strings.errorInputRequired)
      return
    }
    if (!StringUtils.validatePhone(phone)) {
      showToast(props, TOAST_ERROR, Strings.errorPhoneInvalid)
      return
    }
    setLoadingDialog(true)
    let id = StringUtils.getUniqueID()
    let updates = {}
    updates[Constants.ID] = id
    updates[Constants.USER_ID] = userId
    updates[Constants.STORE_ID] = storeId
    updates[Constants.EMAIL] = email
    updates[Constants.FIRST_NAME] = firstName
    updates[Constants.LAST_NAME] = lastName
    updates[Constants.PHONE] = phone
    updates[Constants.ROLE] = Constants.ROLE_GUEST
    updates[Constants.DATE_MODIFIED] = Date.now()
    updates[Constants.DATE_ADDED] = Date.now()
    const httpsCallable = firebase.functions().httpsCallable(Constants.FB_FUNC_STORE_CREATE_CUSTOMER)
    try {
      const httpsResponse = await httpsCallable({ id, storeId, updates })
      if (httpsResponse && httpsResponse.data) {
        if (httpsResponse.data.message) {
          setLoadingDialog(false)
          showToast(props, TOAST_ERROR, httpsResponse.data.message)
          return
        }
      }
    } catch (err) {
      setLoadingDialog(false)
      showToast(props, TOAST_ERROR, err.message || Strings.errorLoadingData)
      return
    }
    setLoadingDialog(false)
    setOpenDialog(false)
    if (props.onCustomerCreated) {
      props.onCustomerCreated(updates)
    }
  }

  const handleCloseDialog = (agree) => {
    if (agree) {
      addCustomer()
    } else {
      setOpenDialog(false)
    }
  }

  props.onAddCustomer = () => {
    setOpenDialog(true)
  }

  const classes = useStyles()

  return <IDialog open={openDialog} maxWidth='sm' fullWidth={true} onClose={() => handleCloseDialog(false)} aria-labelledby='alert-dialog-title' >
    <IDialogContent>
      <IDialogTitle id='alert-dialog-title'>{Strings.addCustomer}</IDialogTitle>
      <div>
        <IFormControl style={{ maxWidth: Styles.formMaxWidth, alignItems: 'center', paddingLeft: 24, marginBottom: Styles.margin2Br }}>
          <ITextField className={classes.textField} label={Strings.firstName + '*'} value={firstName} onChange={(event) => { setFirstName(event.target.value) }} />
          <PhoneInput className={classes.textField} style={{ marginTop: Styles.margin1Br }} label={Strings.phone + '*'} value={phone} onChange={(event) => { setPhone(event) }} />
          <ITextField className={classes.textField} style={{ marginTop: Styles.margin1Br }} label={Strings.email + ' (optional)'} value={email} onChange={(event) => { setEmail(event.target.value) }} />
          <ITextField className={classes.textField} style={{ marginTop: Styles.margin1Br }} label={Strings.lastName + ' (optional)'} value={lastName} onChange={(event) => { setLastName(event.target.value) }} />
          {loadingDialog && <ICircularProgress color='primary' />}
        </IFormControl>
      </div>
      <IDialogActions>
        <IButton onClick={() => handleCloseDialog(false)}>{Strings.cancel}</IButton>
        <IButton onClick={() => handleCloseDialog(true)} autoFocus>{Strings.ok}</IButton>
      </IDialogActions>
    </IDialogContent>
  </IDialog>
}

function ContentView({ props }) {
  Logger.log('ContentView')

  const query = Navigator.getQuery()
  const { settings } = useGlobal()
  const [items, setItems] = useState([])

  useEffect(() => {
    loadData()
  }, [])

  const loadData = (keyword) => {
    setLoading(props, true)
    const httpsCallable = firebase.functions().httpsCallable(Constants.FB_FUNC_STORE_SEARCH_CUSTOMERS)
    httpsCallable({ keyword: StringUtils.trimPhone(keyword) }).then(({ data }) => {
      setLoading(props, false)
      const list = []
      if (data.items) {
        for (let i in data.items) {
          list.push(data.items[i])
        }
      }
      DataUtils.sortBy(list, Constants.FIRST_NAME)
      setItems(list)
    }).catch(err => {
      setLoading(props, false)
      showToast(props, TOAST_ERROR, err.message || Strings.errorLoadingData)
    })
  }

  const onScheduleClick = (item) => {
    const booking = Storage.getJson(Constants.BOOKING)
    booking[Constants.USER] = item
    Storage.setJson(Constants.BOOKING, booking)
    Navigator.back()
  }

  const onAddCustomerClick = () => {
    if (props.onAddCustomer) {
      props.onAddCustomer()
    }
  }

  props.onSearchClick = (keyword) => {
    loadData(keyword)
  }

  props.onCustomerCreated = (item) => {
    onScheduleClick(item)
  }

  const classes = useStyles()
  const isMobile = ScreenUtils.isMobile()

  return <ITableContainer component={IPaper} className={classes.listSection} style={{ marginTop: Styles.margin1Br }}>
    <ITable>
      <ITableBody>
        {items.map(item => (
          <ITableRow key={item[Constants.ID]}>
            <ITableCell className={classes.card}>
              {isMobile && <div>
                <div style={{ display: 'flex' }}>
                  <IImage style={{ width: Styles.imageSize, height: Styles.imageSize }} src={item[Constants.IMAGE] || settings[Constants.DEFAULT_AVATAR] || ''} alt={item[Constants.FIRST_NAME]} />
                  <div style={{ marginLeft: 10 }}>
                    <ITypography variant='body1'><b>{item[Constants.FIRST_NAME]} {item[Constants.LAST_NAME]}</b></ITypography>
                    <ITypography variant='body1'>{item[Constants.EMAIL]}</ITypography>
                    <ITypography variant='body1'>{item[Constants.PHONE]}</ITypography>
                  </div>
                </div>
                <ScheduleButton onClick={() => onScheduleClick(item)}>{Strings.addToVisit}</ScheduleButton>
              </div>}
              {!isMobile && <>
                <IImage style={{ width: Styles.imageSize, height: Styles.imageSize }} src={item[Constants.IMAGE] || settings[Constants.DEFAULT_AVATAR] || ''} alt={item[Constants.FIRST_NAME]} />
                <div className={classes.storeInfo}>
                  <ITypography variant='body1'><b>{item[Constants.FIRST_NAME]} {item[Constants.LAST_NAME]}</b></ITypography>
                  <ITypography variant='body1'>{item[Constants.EMAIL]}</ITypography>
                  <ITypography variant='body1'>{item[Constants.PHONE]}</ITypography>
                  <div className={classes.scheduleButton} style={{ marginTop: Styles.margin1Br }}>
                    <ScheduleButton onClick={() => onScheduleClick(item)}>{Strings.addToVisit}</ScheduleButton>
                  </div>
                </div>
              </>}
            </ITableCell>
          </ITableRow>
        ))}
        <ITableRow key={'guest'}>
          <ITableCell className={classes.card}>
            {isMobile && <div>
              <div style={{ display: 'flex' }}>
                <IImage style={{ width: Styles.imageSize, height: Styles.imageSize }} src={settings[Constants.DEFAULT_AVATAR] || ''} alt={'guest'} />
                <div style={{ marginLeft: 10 }}>
                  <ITypography variant='body1'>{Strings.seachCustomerAddGuestHint}</ITypography>
                </div>
              </div>
              <ScheduleButton onClick={() => onAddCustomerClick()}>{Strings.addCustomer}</ScheduleButton>
            </div>}
            {!isMobile && <>
              <IImage style={{ width: Styles.imageSize, height: Styles.imageSize }} src={settings[Constants.DEFAULT_AVATAR] || ''} alt={'guest'} />
              <div className={classes.storeInfo}>
                <ITypography variant='body1'>{Strings.seachCustomerAddGuestHint}</ITypography>
                <div className={classes.scheduleButton} style={{ marginTop: Styles.margin1Br }}>
                  <ScheduleButton onClick={() => onAddCustomerClick()}>{Strings.addCustomer}</ScheduleButton>
                </div>
              </div>
            </>}
          </ITableCell>
        </ITableRow>
      </ITableBody>
    </ITable>
  </ITableContainer>
}

function ViewCustomers() {
  Logger.log(Constants.PAGES_STORE_ADD_APPOINTMENT_VIEW_CUSTOMERS)

  let props = createPropsWithActions()
  const classes = useStyles()

  return <div className={classes.root}>
    <ITypography variant='h5'>{Strings.customers}</ITypography>
    <SearchView props={props} />
    <ContentView props={props} />
    <AddCustomerView props={props} />
    <ProgressBar props={props} />
    <ToastView props={props} />
  </div>
}

export default ViewCustomers